/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EvalRunStatus = {
  Queued: "queued",
  InProgress: "in_progress",
  Finalizing: "finalizing",
  Completed: "completed",
  Failed: "failed",
  Cancelling: "cancelling",
  Cancelled: "cancelled",
} as const;
export type EvalRunStatus = ClosedEnum<typeof EvalRunStatus>;

/** @internal */
export const EvalRunStatus$inboundSchema: z.ZodNativeEnum<
  typeof EvalRunStatus
> = z.nativeEnum(EvalRunStatus);
/** @internal */
export const EvalRunStatus$outboundSchema: z.ZodNativeEnum<
  typeof EvalRunStatus
> = EvalRunStatus$inboundSchema;
